export default __webpack_public_path__ + "static/media/market-cap.0277a87e.svg";